// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-473aed60]{--text-opacity:1;color:#3182ce;color:rgba(49,130,206,var(--text-opacity));text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
